<template>
    <div>
        <p class="text-center mb-0">{{unidadeSelecionada.cnes}} - {{unidadeSelecionada.nome}}</p>
        <p class="text-center mb-0"><strong>Enfermaria:</strong> {{dados.leitoCodigoEnfermaria}} <strong>Leito:</strong> {{dados.leitoCodigo}}</p>
        <p class="text-center"><strong>{{dados.leitoNomeEnfermaria}}</strong></p>

        <div class="row">
            <div class="col-sm-12 form-group">
                <label>Descrição do Paciente</label>
                <input class="form-control" disabled :value="dados.pacienteNome">
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12 form-group">
                <label for="buscacns">CPF ou CNS</label>
                <div class="input-group">
                    <input type="text" class="form-control" placeholder="Digite o CPF ou CNS" id="buscacns" v-mask="'###############'" v-model="documento">
                    <div class="input-group-append">
                        <button class="btn btn-primary" type="button" id="button-addon2" @click="refreshTokenCallMethod('censo_buscaCns', 'buscaCNS')">
                            <i class="fa fa-search" aria-hidden="true"></i> Atualizar
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { captcha } from '../../../shared/mixins/captcha'
import { validaSessao } from '../../../shared/mixins/validaSessao'

export default {
    mixins: [
        captcha,
        validaSessao
    ],
    props: {
        dados: Object
    },
    computed: {
        unidadeSelecionada () {
            return this.$store.getters['filtro/getUnidadeSelecionada']
        },
        errorCns () {
            return this.$store.getters['consultas/getErrorCns']
        },
        token_captcha () {
            return this.$store.getters['sessao/getCaptcha']
        },
    },
    data () {
        return {
            documento: '',   
        }
    },
    methods: {
        async buscaCNS () {
            if (this.documento.length !== 11 && this.documento.length !== 15) return

            let tpDocumento = ''
            this.documento.length == 11 ?
                tpDocumento = 'cpf' :
                tpDocumento = 'cns'

            let dados = {
                tipoDocumento: tpDocumento,
                numeroDocumento: this.documento,
                'g-recaptcha-response': this.token_captcha,
                idPacienteDesconhecido: this.dados.pacienteCns,
                idLeito: this.dados.leitoId
            }

            this.$emit('atualizar', dados)
        },
    }
}
</script>

<style>
    
</style>